<template>
    <Header></Header>
    <Left></Left>
    <section class="container flex">
        <div class="blue_box flex_4">
            <div class="box_tit _flex">
                <h2>답변 미완료 제보</h2>
                <div class="info_box">
                    <div>
                        총
                        <span class="col_blue">{{ noCommentState.totalLength }}건</span>
                    </div>
                </div>
            </div>
            <div class="common_table">
                <table>
                    <colgroup>
                        <col style="width: 80px" />
                        <col />
                        <col style="width: 180px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>게시판</th>
                            <th>작성일</th>
                            <th>답변여부</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="noCommentState.list && noCommentState.list.length > 0">
                            <tr v-for="(item, idx) in noCommentState.list" :key="idx">
                                <td class="list_num">{{ (noCommentState.page - 1) * noCommentState.size + idx + 1 }}</td>
                                <td class="underline">
                                    <RouterLink :to="{ name: item.type === 3 ? 'qnaList' : 'reportList', query: { type: item.type === 1 ? 1 : 2 } }">
                                        {{ item.type === 1 ? "성매매 의심업소" : item.type === 2 ? "성매매 알선광고" : "[1:1 문의] " + item.title }}
                                    </RouterLink>
                                </td>
                                <td>{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                <td class="cnt p_5">{{ item.type === 3 ? "미완료" : "대기중" }}</td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="4"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="noCommentState.list.length !== 0"
                :currentPage="noCommentState.page"
                :totalLength="noCommentState.totalLength"
                :perPage="noCommentState.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
        <div class="blue_box flex_3">
            <div class="box_tit _flex">
                <h2 class="pointer">
                    <RouterLink :to="{ name: 'reportList' }">
                        시민제보 현황
                        <img src="img/view_more.png" alt="" />
                    </RouterLink>
                </h2>
                <div class="info_box">
                    <div>
                        총
                        <span class="col_blue">
                            {{
                                CommonUtils.numberFormat(
                                    getCntByCn(0 + "", reportState.list1) +
                                        getCntByCn(1 + "", reportState.list1) +
                                        getCntByCn(1 + "", reportState.list2) +
                                        getCntByCn(2 + "", reportState.list2) +
                                        getCntByCn(3 + "", reportState.list2) +
                                        getCntByCn(4 + "", reportState.list2),
                                )
                            }}건
                        </span>
                    </div>
                </div>
            </div>
            <div class="common_table mini_blue_box small_size">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: 154px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>게시판</th>
                            <th>분류</th>
                            <th>게시물 총건수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in reportState.list1">
                            <td class="cnt">{{ idx + 1 }}</td>
                            <td class="underline"><RouterLink :to="{ name: 'reportList', query: { type: 1 } }">성매매 의심 업소 제보</RouterLink></td>
                            <td>{{ item.targetCol === "0" ? "학교 주변 외" : "학교주변" }}</td>
                            <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="total">
                    <thead>
                        <tr>
                            <th>합계</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2" class="cnt p_5">
                                {{ CommonUtils.numberFormat(getCntByCn(0 + "", reportState.list1) + getCntByCn(1 + "", reportState.list1)) }}건
                            </td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>
            <div class="common_table mini_blue_box small_size">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 170px" />
                        <col style="width: 154px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>번호</th>
                            <th>게시판</th>
                            <th>분류</th>
                            <th>게시물 총건수</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in reportState.list2">
                            <td class="cnt">{{ idx + 1 }}</td>
                            <td class="underline"><RouterLink :to="{ name: 'reportList', query: { type: 2 } }">성매매 알선 광고 제보</RouterLink></td>
                            <td>
                                {{
                                    item.targetCol === "1"
                                        ? "온라인알선광고"
                                        : item.targetCol === "2"
                                        ? "지면광고"
                                        : item.targetCol === "3"
                                        ? "불법 옥외 광고물"
                                        : "기타"
                                }}
                            </td>
                            <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                        </tr>
                    </tbody>
                </table>
                <table class="total">
                    <thead>
                        <tr>
                            <th>합계</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2" class="cnt p_5">
                                {{
                                    CommonUtils.numberFormat(
                                        getCntByCn(1 + "", reportState.list2) +
                                            getCntByCn(2 + "", reportState.list2) +
                                            getCntByCn(3 + "", reportState.list2) +
                                            getCntByCn(4 + "", reportState.list2),
                                    )
                                }}건
                            </td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="blue_box _flex mini_blue_box_wrap">
            <div class="box_tit _flex">
                <h2>접속자 현황</h2>
            </div>
            <div class="mini_blue_box _full">
                <div class="sch_condition_wrap">
                    <div class="left _flex _align_bottom">
                        <div class="select_date_wrap _120">
                            <div class="select_date">
                                <input type="date" v-model="visitHistoryState.startDate" @change="getVisitHistory" />
                            </div>
                            <div class="select_date">
                                <input type="date" v-model="visitHistoryState.endDate" @change="getVisitHistory" />
                            </div>
                        </div>
                        <span class="graph_info">*최근 1년까지 검색 가능합니다.</span>
                    </div>
                </div>
                <div class="graph_wrap">
                    <Chart
                        v-if="visitHistoryState.isDraw"
                        :titlePadding="visitHistoryState.titlePadding"
                        :data="visitHistoryState.data"
                        :legendPosition="visitHistoryState.legendPosition"
                        :width="visitHistoryState.chartWidth"
                        :height="visitHistoryState.chartHeight"
                        :title="visitHistoryState.title"
                        :subTitle="visitHistoryState.subTitle"
                    ></Chart>
                </div>
            </div>
            <div class="mini_blue_box">
                <div class="box_tit _flex">
                    <h3>Daily (일간)</h3>
                    <div class="info_box">
                        <div>최근 6일간</div>
                    </div>
                </div>
                <div class="common_table small_size">
                    <table>
                        <colgroup>
                            <col style="width: 160px" />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>날짜</th>
                                <th>접속자</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="visitHistoryRecentState.list1 && visitHistoryRecentState.list1.length > 0">
                                <tr v-for="item in visitHistoryRecentState.list1">
                                    <td>{{ CommonUtils.dateFormatYYMMDDDay(item.targetCol, ".") }}</td>
                                    <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="2"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="mini_blue_box">
                <div class="box_tit _flex">
                    <h3>Weekly (주간)</h3>
                    <div class="info_box">
                        <div>최근 6주간</div>
                    </div>
                </div>
                <div class="common_table small_size">
                    <table>
                        <colgroup>
                            <col style="width: 160px" />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>날짜</th>
                                <th>접속자</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="visitHistoryRecentState.list2 && visitHistoryRecentState.list2.length > 0">
                                <tr v-for="item in visitHistoryRecentState.list2">
                                    <td>
                                        {{
                                            CommonUtils.dateFormatYYMMDD(item.targetCol.split("~")[0], ".") +
                                            " ~ " +
                                            CommonUtils.dateFormatYYMMDD(item.targetCol.split("~")[1], ".")
                                        }}
                                    </td>
                                    <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="2"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="mini_blue_box">
                <div class="box_tit _flex">
                    <h3>Monthly (월간)</h3>
                    <div class="info_box">
                        <div>최근 6개월</div>
                    </div>
                </div>
                <div class="common_table small_size">
                    <table>
                        <colgroup>
                            <col style="width: 160px" />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>월</th>
                                <th>접속자</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="visitHistoryRecentState.list3 && visitHistoryRecentState.list3.length > 0">
                                <tr v-for="item in visitHistoryRecentState.list3">
                                    <td>{{ CommonUtils.dateFormatYYMM(item.targetCol, ".") }}</td>
                                    <td>{{ CommonUtils.numberFormat(item.cnt) }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="2"><div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        types,
        PageBtn,
        CommonUtils,
        chart,
        getMessageByCode,
        ModalDefault,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, PageBtn, Chart: chart, ModalDefault },
        setup() {
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const noCommentState = reactive({
                page: 1 as number,
                size: 5 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as any[],
            });
            const reportState = reactive({
                list1: [] as Array<types.GroupResult>,
                sum1: 0 as number,

                list2: [] as Array<types.GroupResult>,
                sum2: 0 as number,
            });

            const visitHistoryState = reactive({
                list: [] as Array<types.GroupResult>,
                startDate: "" as string,
                endDate: "" as string,

                isDraw: false as boolean,

                title: " ", // O
                subTitle: "", // O
                defaultType: "" as string, // line, bar, pie, donut, candle 차트의 초기 값입니다.
                titlePadding: [] as Array<number>, //[up,right,down,left]
                data: {
                    data: [
                        [276, 132, 101, 134, 90],
                        [290, 200, 150, 170, 120],
                        [310, 210, 160, 180, 130],
                        [320, 220, 170, 190, 140],
                        [200, 230, 180, 200, 150],
                    ] as any,
                    legend: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
                    category: ["Mon", "Tue", "Wed", "Thu", "Fri"],
                },
                legendPosition: "left" as string, // 'left' bottom
                chartWidth: "100%" as string,
                chartHeight: "15vh" as string,
            });

            const visitHistoryRecentState = reactive({
                list1: [] as Array<types.GroupResult>,
                list2: [] as Array<types.GroupResult>,
                list3: [] as Array<types.GroupResult>,
            });

            onMounted(() => {
                global.$reset();
                global.chartSet("line");

                getNoComment();
                getReport(1);
                getReport(2);
                getVisitHistory();
                getVisitHistoryRecent(1);
                getVisitHistoryRecent(2);
                getVisitHistoryRecent(3);
            });

            const getNoComment = async () => {
                const param: types.ReqCommonPaging = {
                    page: noCommentState.page,
                    size: noCommentState.size,
                    searchType: null,
                    searchText: null,
                };

                const res = await apiService.dashboard.noComment(param);

                if (res.returnCode === 0) {
                    noCommentState.list = res.list.data;
                    noCommentState.totalPage = res.list.totalPages;
                    noCommentState.totalLength = res.list.recordsTotal;
                } else {
                    console.error(res.description);
                }
            };

            const getReport = async (type: 1 | 2) => {
                const res: types.ResReportListForDashboard = await apiService.dashboard.report(type);

                if (res.returnCode === 0) {
                    if (res.list) {
                        if (type === 1) {
                            reportState.list1 = res.list;
                            reportState.sum1 = res.sum;
                        } else {
                            reportState.list2 = res.list;
                            reportState.sum2 = res.sum;
                        }
                    }
                } else {
                    console.error(res.description);
                }
            };

            const getVisitHistory = async () => {
                visitHistoryState.isDraw = false;
                const param: types.ReqParamForDashboard = {
                    startDate: visitHistoryState.startDate,
                    endDate: visitHistoryState.endDate,
                };

                const res = await apiService.dashboard.visitHistory(param);

                if (res.returnCode === 0) {
                    visitHistoryState.list = res.list;

                    const category = visitHistoryState.list.map((item) => CommonUtils.dateFormatYYMMDD(item.targetCol));
                    const data = visitHistoryState.list.map((item) => item.cnt);

                    visitHistoryState.data.data = [data];
                    visitHistoryState.data.legend = ["date"];
                    visitHistoryState.data.category = category;

                    visitHistoryState.isDraw = true;
                } else {
                    console.error(res.description);
                }
            };

            const getVisitHistoryRecent = async (type: 1 | 2 | 3) => {
                const res: types.ResVisitHistoryForDashboard = await apiService.dashboard.visitHistoryRecent(type);

                if (res.returnCode === 0) {
                    if (type === 1) {
                        visitHistoryRecentState.list1 = res.list;
                    } else if (type === 2) {
                        visitHistoryRecentState.list2 = res.list;
                    } else {
                        visitHistoryRecentState.list3 = res.list;
                    }
                } else {
                    console.error(res.description);
                }
            };

            const handlePageChange = (page: number) => {
                noCommentState.page = page;
                getNoComment();
            };

            const getCntByCn = (cn: string, list: Array<types.GroupResult>) => {
                return list.find((item) => item.targetCol === cn)?.cnt ?? 0;
            };

            const closeModal = () => {
                state.isShowModal = false;
                state.modalTab = -1;
            };

            const openModal = (tab: number, isResult: boolean) => {
                state.modalTab = tab;
                state.isShowModal = true;
                state.modalIsResult = isResult;
            };

            const callBackModal = async (param: any) => {};

            return {
                state,
                user,
                router,
                global,
                noCommentState,
                reportState,
                visitHistoryState,
                visitHistoryRecentState,
                handlePageChange,
                CommonUtils,
                getCntByCn,
                getVisitHistory,
                closeModal,
                openModal,
                callBackModal,
            };
        },
    };
</script>
